import React from 'react';
import { Checkbox, Field } from '../../../../../../Core';
import { ListFieldSection } from '../../../../../../Layout';
import { withInjectedProps } from '../../../../../../Core/InjectedPropsContext';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';

let ResultsChartOptionsSection: React.FC<IWorksheetComponent> = () => (
  <ListFieldSection single>
    <Field
      input={<Checkbox />}
      label="Join specification points on chart"
      name="Results.ChartOptions.JoinSpecificationPoints"
    />
  </ListFieldSection>
);

ResultsChartOptionsSection = withInjectedProps(ResultsChartOptionsSection);

export { ResultsChartOptionsSection };
export default ResultsChartOptionsSection;
